import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import { eliminarSubsubcategoriaConfiguracion } from '../../../../../actions/configuracion';

const EliminarSubsubcategoria = ({ subsubcategoria, reestablecerSubsubcategoria }) => {

    const dispatch =  useDispatch();

    const [eliminarModal, setEliminarModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    /* Eliminar subsubcategoria */
    const handleProcesar = async () => {
        await setStatusProcesar(true);
        await dispatch(eliminarSubsubcategoriaConfiguracion(subsubcategoria?.id));
        await handleCerrar();
        await setStatusProcesar(false);
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            reestablecerSubsubcategoria(null);
            setEliminarModal(false);
        }
    }

    useEffect(() => {
        if(subsubcategoria){
            setEliminarModal(true);
        }
    }, [subsubcategoria]);

    return (
        <Modal show={eliminarModal} backdrop="static" centered onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Eliminar área</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>¿Deseas eliminar a <b>{subsubcategoria?.nombre}{subsubcategoria?.productos > 0 ? ' con ' + subsubcategoria?.productos + (subsubcategoria?.productos == 1 ? ' producto asignado' : ' productos asignados') : ''}</b>?</p>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-danger mr-3" onClick={() => handleCerrar()} disabled={ statusProcesar }><i className="fas fa-times fa-sm"></i> No</button>
                {
                    statusProcesar ?
                        <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Si</button>
                    :
                        <button type="button" className="btn btn-success" onClick={() => handleProcesar()}><i className="fas fa-check fa-sm"></i> Si</button>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default EliminarSubsubcategoria;